import AccountAndRoutingModal from "./AccountAndRoutingModal";

export default AccountAndRoutingModal;
